import _ from 'lodash';
import mobx, { action, autorun, observable, when } from 'mobx';
import pathToRegexp from 'path-to-regexp';
import accountStore from '../accountStore';
import appStore from '../appStore';
import routingStore from '../routingStore';
import Basket from './basket';
import Line from './line';
import Menu from './menu';
import Schedule from './schedule';
import igStore from '~/components/ig/store';
import * as MatchesList from '~/web-frontend-core/store/line/MatchesList';
import { COLUMN_WIDTH } from '~/web-frontend-core/ws-api/const/base';
import { SITE_TYPE } from '~/config';


class parseUrl {
  store = null;
  route = null;
  afterUrl = {};
  @observable params = null;
  mode = '';
  run = null;

  constructor(store) {
    this.store = store;
    when(
      () => this.store.line.status,
      () => this.init()
    );
  }

  init() {
    if (this.run) this.run();
    this.run = autorun(() => {
      this.getUrl2(this.params);
    });
  }

  despose() {
    this.afterUrl = {};
  }

  @action setUrl(params) {
    if (!_.isEqual(mobx.toJS(this.params), params)) this.params = params;
    // this.getUrl2(this.params);
  }

  @action getUrl2(params) {
    this.mode = this.store.mode;
    if (!params) { return; }
    let param1 = params.sport ? params.sport.split('-') : [];
    const firstParam = param1[0];

    if (!firstParam && this.mode === 'line') {
      //       const sport = this.store.menu.sport.keys().map(Number)
      // ;      this.store.menu.selectItem({
      //         sport,
      //         league: [],
      //         games: [],
      //       }, 1);
      this.store.menu.selectItem('pop', 4);
    } else if (firstParam === 'other' && this.mode === 'line') {
      this.store.menu.selectOther();
    } else if (firstParam === 'popular' && this.mode === 'line') {
      let id = params.league ? params.league.split('-') : '';

      if (id) {
        if (this.afterUrl === `popular/${id}`) return false;
        this.store.menu.selectItem(id, 5);
        this.afterUrl = `popular/${id}`;
      } else {
        if (this.afterUrl === 'popular') return false;
        this.store.menu.selectItem('pop', 4);
      }

      return;
    } else if (firstParam === 'video' && this.mode === 'live') {
      this.store.menu.selectItem('video', 6);
    } else if (firstParam === 'schedule' && this.mode === 'live') {
      if (this.afterUrl === firstParam) return false;
      this.store.toggleSchedule(true);
      this.afterUrl = param1[0];
      return;
    } else if (firstParam === 'favourites') {
      if (this.store.menu.favourites.games.length || this.store.menu.favourites.popular.pop.length) {
        this.store.menu.selectItem('fav', 0);
      } else {
        // window.location = `/${this.mode}`;
        appStore.history.push(`/${this.mode}`);
      }
    } else {
      let type = 1;
      let league = params.league ? params.league.split('-') : [];
      let games = params.games ? params.games.split('-') : [];
      // const ross = params.ross ? 1 : 0;

      if (param1.length && league.length && games.length) {
        type = 3;
      } else if (param1.length && league.length) {
        type = 2;
      }

      param1 = param1.map(i => Number(i));
      league = league.map(i => Number(i));
      games = games.map(i => Number(i));

      if (this.mode === 'line' && (this.afterUrl && this.afterUrl.sport === params.sport && this.afterUrl.league === params.league && this.afterUrl.games === params.games)) return;
      this.afterUrl = params;
      this.store.menu.selectItem({ sport: param1, league, games }, type, 1);
    }

  }

  getUrl(location) {
    // console.log(location)
    const re = pathToRegexp('/:sport?/:league?/:games?/:ross?');
    const path = re.exec(location.pathname);
    const mode = path[1];
    this.mode = mode;
    let param1 = path[2] ? path[2].split('-') : [];

    if (param1[0] == 'schedule') {
      // console.log(param1[0]);
      if (this.afterUrl == param1[0]) return false;
      this.store.toggleSchedule(true);
      this.afterUrl = param1[0];
      return;
    } else if (param1 == 'favourites') {
      if (this.store.menu.favourites.games.length) {
        this.store.menu.selectItem('fav', 0);
      } else {
        this.route.push(`/${mode}`);
      }
    } else {
      // console.log(this.afterUrl);
      let type = 1;
      let league = path[3] ? path[3].split('-') : [];
      let games = path[4] ? path[4].split('-') : [];
      const ross = path[5] ? 1 : 0;

      if (param1.length && league.length && games.length) {
        type = 3;
      } else if (param1.length && league.length) {
        type = 2;
      }

      param1 = param1.map(i => Number(i));
      league = league.map(i => Number(i));
      games = games.map(i => Number(i));

      if (mode == 'line' && (this.afterUrl && this.afterUrl.sport == path[2] && this.afterUrl.league == path[3] && this.afterUrl.games == path[4])) return;

      this.afterUrl = {
        sport: path[2],
        league: path[3],
        games: path[4]
      };

      this.store.menu.selectItem({ sport: param1, league, games }, type, 1);
    }

  }

}

export class lineStore {

  @observable col = 3;
  @observable mode = null;
  @observable line;
  @observable menu = null;
  @observable schedule = null;
  @observable scheduleActive = false;
  @observable basket = null;
  @observable isLoading = true;
  @observable shortMenu = false;
  @observable route = null;
  @observable liveRefreshInterval = 3000;
  @observable liveRefreshOne = 3000;
  // @observable liveSetting = {
  // 	refresh: 3000,
  // 	resresh_one: 3000
  // };
  HIDE_WIDTH = 600;

  constructor(appStore) {
    this.line = new Line(this, accountStore, appStore);
    this.menu = new Menu(this, accountStore);
    this.basket = new Basket(this, accountStore, appStore);
    this.route = new parseUrl(this, routingStore);

    // const withStatsMatches = /^(zenitbet|desktop|mobile_new|mobile_com)$/.test(getConfig('APP_NAME'));
    /** Хранилище live матчей */
    this.matchesList = MatchesList.getInstance({
      width: window.innerWidth < this.HIDE_WIDTH ? COLUMN_WIDTH.SMALL : COLUMN_WIDTH.MEDIUM,
      getSocket: igStore.getSocket,
      webSocketURL: igStore.url,
      withStatsMatches: true,
      site: SITE_TYPE.IRM_CUPIS,
      isMobile: false,
      timezone: 3,
      lng: 1049,
    });
    this.subscribeMathesList()
  }

  subscribeMathesList() {
    const favouritesStore = this.line.store.menu;
    this.matchesList.matches.onFavorite(favouritesStore.favoriteMatch);
    this.matchesList.championships.onFavorite((championshipID, matchIDs, isFavourite) => {
      favouritesStore.favoriteChampionship(championshipID, isFavourite);
      matchIDs.forEach((matchID) => {
        this.matchesList.matches.favoriteMatch(matchID, isFavourite);
      });
    })
  }

  @action init(mode, params) {
    this.clear();
    this.mode = mode;
    this.line = new Line(this, accountStore, appStore);
    // setTimeout(() => {
    if (this.mode) {
      const siteType = SITE_TYPE.IRM_CUPIS;
      if (siteType !== SITE_TYPE.IRM_CUPIS) {
        this.matchesList = MatchesList.getInstance({
          width: window.innerWidth < this.HIDE_WIDTH ? COLUMN_WIDTH.SMALL : COLUMN_WIDTH.MEDIUM,
          getSocket: igStore.getSocket,
          webSocketURL: igStore.url,
          withStatsMatches: true,
          isMobile: false,
          timezone: 3,
          lng: 1049,
          siteType,
        });
      }
      this.menu.init();
      this.basket.init();
      // this.route.init();
      this.isLoading = false;
      if (this.mode == 'live') {
        this.schedule = new Schedule(this);
      }
      this.getShortMenu();
    }
    // }, 1000);
  }

  @action init2() {
    this.line.init();
    this.route.init();
    // this.toggleSchedule(1); // только для разработки
  }

  @action toggleSchedule(status) {
    // if (this.scheduleActive && status) return;

    if (this.mode == 'live') {
      if (status) {
        this.scheduleActive = true;
        this.schedule.init();
        this.menu.clearSelected();
        clearInterval(this.line.refreshTimer);
      } else {
        this.scheduleActive = false;
      }
    }
  }

  @action getShortMenu() {
    const ls = JSON.parse(localStorage.getItem(`left_menu_toggle_${this.mode}`));

    if (ls && accountStore.accountSettings.basketPosition == 'right') {
      this.shortMenu = ls;
    } else {
      this.shortMenu = false;
      localStorage.setItem(`left_menu_toggle_${this.mode}`, false);
    }
  }

  @action setShortMenu() {
    if (accountStore.accountSettings.basketPosition == 'right') {
      this.shortMenu = !this.shortMenu;
      localStorage.setItem(`left_menu_toggle_${this.mode}`, this.shortMenu);
    }
  }

  @action clear() {
    if (this.mode == 'live') this.schedule.despose();
    this.mode = '';
    this.line.despose();
    this.menu.despose();
    // не чистим корзину при переключении режима
    // this.basket.despose();
    this.isLoading = true;
    this.route.despose();
    if (this.route.run) this.route.run();
  }

  @action clearnterval() {
    clearInterval(this.line.refreshTimer);
    clearInterval(this.menu.refreshTimer);
    clearInterval(this.menu.refreshVideoTimer);
  }

  // TODO разобраться что это и зачем
  sideEffect = () => {
    localStorage.setItem('lastAction', (this.mode === 'line') ? '1' : '0');
  }
  // @action calcHeigth() {
  // 	const x = document.querySelector('#wrapper-scroll-menu');
  // 	const y = document.querySelector('#line-left-column');

  // 	console.log(x.offsetHeight , y.offsetHeight );

  // }
}

export default lineStore;


// WEBPACK FOOTER //
// ./src/stores/lineStore/index.js